import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title title-big"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "title title-small" }
const _hoisted_4 = { class: "desc-small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaretRightFilled = _resolveComponent("CaretRightFilled")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['ImgUrl' + _ctx.num, _ctx.size, ['bgImg', 'scheme']]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPage(_ctx.title[_ctx.num].id)))
  }, [
    (_ctx.size == 'big')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "智慧管理系统解决方案"))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title[_ctx.num].title), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title[_ctx.num].desc), 1)
        ])),
    _createElementVNode("div", {
      class: _normalizeClass([['scheme-button'], 'scheme-button-' + _ctx.size])
    }, [
      _cache[1] || (_cache[1] = _createTextVNode(" 了解更多 ")),
      _createVNode(_component_CaretRightFilled, { class: "scheme-button-icon" })
    ], 2)
  ], 2))
}